import PageSubscriptionButton from './PageSubscriptionButton';

export default PageSubscriptionButton;
